module.exports = __webpack_public_path__ + "media/images/talent/lp/step01-93745574081f7bccf1c83867e9ebe3f9.png";